export const FETCH_REQUEST: 'productReviews/FETCH_REQUEST' =
  'productReviews/FETCH_REQUEST'
export const FETCH_SUCCESS: 'productReviews/FETCH_SUCCESS' =
  'productReviews/FETCH_SUCCESS'
export const FETCH_FAILURE: 'productReviews/FETCH_FAILURE' =
  'productReviews/FETCH_FAILURE'
export const INIT: 'productReviews/INIT' = 'productReviews/INIT'
